import { AsyncLoader } from "./AsyncLoader";

interface IAjaxLoaderProps {
    IsActive?: boolean;
    ClearStyle?: boolean;
}

class AsyncLoaderControl extends React.Component<IAjaxLoaderProps, never> {
    public render(): JSX.Element {
        const loaderStyle = {
            zIndex: 100,
            position: "absolute",
            bottom: "5%",
            left: "2%"
        } as React.CSSProperties;

        if (this.props.ClearStyle === true) {
            delete loaderStyle.zIndex;
            delete loaderStyle.position;
            delete loaderStyle.bottom;
            delete loaderStyle.left;
        }

        if (this.props.IsActive) {
            return (
                <div style={loaderStyle} data-cy="loader-img">
                    <AsyncLoader />
                </div>
            );
        }
        else {
            return (
                <div style={loaderStyle}>
                    <span />
                </div>
            );
        }
    }
}

export { AsyncLoaderControl };
